export const modalActualizacionCv = {
  title: 'Es necesario que actualices tu {{cv}} para aumentar tu visibilidad.',
  description:
    'Los empleadores necesitan que tu perfil esté al día. Puedes hacerlo manualmente o cargar tu {{cv}} en PDF para que nuestra IA lo actualice.',
  cta: 'Actualizar mi {{cv}}',
}
